<template>
  <div class="index-content2">
    <div class="title-container">
      <div class="title-dec-left">
        <img src="@/assets/image/title-dec.png" alt="title decoration left" />
      </div>
      <div class="title-text">城市代理优势</div>
      <div class="title-dec-right">
        <img src="@/assets/image/title-dec.png" alt="title decoration right" />
      </div>
    </div>
    <div class="tip">加入我们，共享智慧酒吧市场红利</div>
    <div class="item-show-container">
      <div
        v-for="(item, index) in itemList"
        :key="index"
        class="item"
      >
        <div class="icon-container">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20 6L9 17L4 12" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <div class="content-container">
          <div class="title">
            <img src="@/assets/image/title-arrow.png" alt="arrow left" class="arrow-left" />
            <span class="title-text">{{ item.title }}</span>
            <img src="@/assets/image/title-arrow.png" alt="arrow right" class="arrow-right" />
          </div>
          <div class="subtitle">{{ item.subtitle }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CityContent2',
  data() {
    return {
      itemList: [
        {
          title: '低门槛，零风险，高收益',
          subtitle: '无额外加盟费，有推广渠道即可零成本创业，永享代理收益',
        },
        {
          title: '独家区域保护',
          subtitle: '每个城市仅招募一家城市代理合作伙伴，确保区域市场独占性',
        },
        {
          title: '全方位培训支持',
          subtitle: '全公司提供产品、销售、技术等全套培训支持',
        },
        {
          title: '营销推广支持',
          subtitle: '提供宣传册、演示视频、推广方案等全套营销物料',
        },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.index-content2 {
  width: 100%;
  height: auto;
  margin-top: 53px;
  
  .title-container {
    height: 43px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: flex-end;
    gap: 12px;
    
    .title-dec-left {
      img {
        width: 75px;
        height: 26px;
        display: block;
        object-fit: contain;
      }
    }
    
    .title-text {
      font-weight: 700;
      font-size: 30px;
      color: #FFFFFF;
      align-self: flex-end;
      line-height: 1;
    }
    
    .title-dec-right {
      img {
        width: 75px;
        height: 26px;
        display: block;
        object-fit: contain;
        transform: scaleX(-1);
      }
    }
  }
  
  .tip {
    font-weight: 500;
    font-size: 19px;
    color: #FFFFFF;
    text-align: center;
    margin-top: 10px;
  }
  
  .item-show-container {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 34px;
    margin-top: 35px;
    flex-wrap: wrap;
    
    .item {
      width: 558px;
      height: 145px;
      background: linear-gradient(89deg, #212A92 0%, rgba(135, 65, 209, 0.6) 100%);
      border-radius: 12px;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: flex-start;
      padding: 30px 25px;
      
      .icon-container {
        width: 47px;
        height: 47px;
        background: linear-gradient(180deg, #FF21FB 0%, #8964FF 100%);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        
        svg {
          width: 30px;
          height: 30px;
        }
      }
      
      .content-container {
        width: 443px;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        margin-left: 18px;
        
        .title {
          display: flex;
          flex-direction: row;
          align-items: center;
          gap: 8px;
          
          .arrow-left {
            width: 26px;
            height: 22px;
            transform: scaleX(-1);
            display: block;
          }
          
          .title-text {
            font-weight: 700;
            font-size: 26px;
            line-height: 26px;
            color: #FFFFFF;
            display: block;
          }
          
          .arrow-right {
            width: 26px;
            height: 22px;
            display: block;
          }
        }
        
        .subtitle {
          font-weight: 500;
          font-size: 16px;
          color: #FFFFFF;
          margin-top: 20px;
        }
      }
    }
  }
}
</style>
